/* Deferred mobile-menu logic (search, wishlist, geo, active-highlight, expandable),
   extracted from snippets/mobile-menu-v2.liquid to keep it out of pre-hero HTML.
   Loaded via <script defer> after esim-search-core.js. Core burger open/close stays
   inline in the snippet (needs to run immediately). Asset URLs via window.__MM_ASSETS. */
(function(){
  /* ===== Wishlist badge: hide when 0, show count when > 0 ===== */
  (function() {
    function syncWishlistBadge() {
      var list = [];
      try { list = JSON.parse(localStorage.getItem('sf-wishlist') || '[]'); } catch(e) {}
      document.querySelectorAll('.sf-wishlist-count').forEach(function(b) {
        if (list.length > 0) {
          b.textContent = list.length;
          b.style.display = '';
        } else {
          b.textContent = '';
          b.style.display = 'none';
        }
      });
    }
    syncWishlistBadge();
    // Re-sync after MINIMOG's app.min.js may override
    setTimeout(syncWishlistBadge, 1000);
    setTimeout(syncWishlistBadge, 3000);
  })();

  /* ===== Active Page Highlighting ===== */
  var currentPath = window.location.pathname;
  document.querySelectorAll('.hdr2__nav-item, .hdr2__mobile-link').forEach(function(a) {
    var href = a.getAttribute('href');
    if (href && currentPath === href) {
      a.classList.add('is-active');
    }
  });

  /* ===== Mobile Expandable Sections ===== */
  document.querySelectorAll('.hdr2__mobile-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = btn.getAttribute('data-mobile-toggle');
      var sub = document.querySelector('[data-mobile-sub="' + key + '"]');
      if (!sub) return;
      var isOpen = sub.classList.contains('is-open');
      /* Close all other sections first */
      document.querySelectorAll('.hdr2__mobile-sub.is-open').forEach(function(el) { el.classList.remove('is-open'); });
      document.querySelectorAll('.hdr2__mobile-toggle.is-open').forEach(function(el) {
        el.classList.remove('is-open');
        el.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        sub.classList.add('is-open');
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  /* Currency selects now use Shopify form 'localization' — auto-synced by Shopify */

  /* ===== Mobile Search — full-featured via GstarSearchCore ===== */
  (function() {
    var GLOB = {
      '_globe': window.__MM_ASSETS.globe,
      '_globe_eu': window.__MM_ASSETS.globe_eu,
      '_globe_af': window.__MM_ASSETS.globe_af,
      '_globe_as': window.__MM_ASSETS.globe_as,
      '_globe_oc': window.__MM_ASSETS.globe_oc,
      '_globe_na': window.__MM_ASSETS.globe_na,
      '_globe_sa': window.__MM_ASSETS.globe_sa,
      '_globe_world': window.__MM_ASSETS.globe_world
    };
    var FLAG_BASE = window.__MM_ASSETS.flagBase.split('flag-jp.png')[0];
    var flagOpts = { flagBase: FLAG_BASE + 'flag-', globeUrls: GLOB };

    function init() {
      var C = window.GstarSearchCore;
      if (!C) { setTimeout(init, 30); return; }

      var input = document.getElementById('hdr2-mobile-search-input');
      var results = document.getElementById('hdr2-mobile-search-results');
      if (!input || !results) return;

      var debounceTimer = null;
      var activeIndex = -1;
      var fetchIdRef = { id: 0 };

      function renderItem(flagCode, title, subtitle, url, isActive) {
        var imgHtml = C.renderFlag(flagCode || '_globe', 36, flagOpts);
        return '<a href="' + url + '" class="hdr2__mobile-search-result' + (isActive ? ' hdr2__mobile-search-result--active' : '') + '">' +
          imgHtml +
          '<div class="hdr2__mobile-search-result__info">' +
            '<p class="hdr2__mobile-search-result__title">' + title + '</p>' +
            (subtitle ? '<p class="hdr2__mobile-search-result__price">' + subtitle + '</p>' : '') +
          '</div></a>';
      }

      /* Mirrors the hero dropdown: the typed text is bolded inside the result
         title. The header boxes rendered plain escaped text, so the same query
         was highlighted on the homepage and not in the header. escapeHtml
         stays the fallback for the popular list, which has no query. */
      function titleHtml(text, query) {
        return query ? C.highlightMatch(text, query) : C.escapeHtml(text);
      }

      function renderResults(dests, coverage, products, articles, query, isPopular) {
        var hasDests = dests && dests.length > 0;
        var hasCov = coverage && coverage.length > 0;
        var hasProds = products && products.length > 0;
        var hasArts = articles && articles.length > 0;

        if (!hasDests && !hasCov && !hasProds && !hasArts) {
          results.innerHTML = '<div class="hdr2__mobile-search-no-results">' +
            C.i18n('noResultsFor', { query: C.escapeHtml(query) }) +
            '<br><span style="font-size:0.8rem;color:#94a3b8;margin-top:4px;display:inline-block;">' + C.i18n('tryHint') + '</span>' +
            C.helpLinksHtml() + '</div>';
          results.classList.add('is-open'); return;
        }

        /* Continent-level query → render Regions before Plans (Region is
           the user's intent for "Europe" / "Asia" / 欧洲 / アジア). */
        var continentPriority = !isPopular && hasDests && C.isContinentQuery && C.isContinentQuery(query, dests);

        var html = '';
        if (isPopular) html += '<div class="hdr2__mobile-search-section-label">' + C.i18n('sectionPopular') + '</div>';

        function appendCoverage() {
          if (!hasCov) return;
          if (!isPopular) {
            var topBorder = continentPriority ? ' style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;"' : '';
            html += '<div class="hdr2__mobile-search-section-label"' + topBorder + '>' + C.i18n('sectionAvailable') + '</div>';
          }
          coverage.forEach(function(p) {
            var fc = C.getFlagForProduct(p.t) || C.getFlagForHandle(p.h) || '_globe';
            var cLabel = p.c === 1 ? '' : ' <span style="font-size:0.7rem;background:#f1f5f9;border-radius:999px;padding:2px 6px;">' + C.i18n('nCountries', { count: p.c }) + '</span>';
            html += renderItem(fc, titleHtml(p.t, query) + cLabel, C.i18n('priceFrom', { price: C.currencySymbol + (p.p / 100).toFixed(2) }), C.localizeUrl('/products/' + p.h));
          });
        }
        function appendDests() {
          if (!hasDests) return;
          dests.forEach(function(d) {
            var sub = C.priceCache[d.name] ? C.i18n('priceFrom', { price: C.priceCache[d.name] }) : C.i18n('browseCollection');
            html += renderItem(d.flag, titleHtml(d.name, query), sub, C.localizeUrl(C.resolveDestUrl(d.url)));
          });
        }

        if (continentPriority) { appendDests(); appendCoverage(); }
        else { appendCoverage(); appendDests(); }

        if (hasProds) {
          if (!isPopular) html += '<div class="hdr2__mobile-search-section-label" style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;">Plans</div>';
          products.forEach(function(p) {
            var fc = C.getFlagForProduct(p.title) || '_globe';
            var priceNum = parseFloat(p.price_min || p.price || '0');
            var sub = priceNum > 0 ? C.i18n('priceFrom', { price: C.currencySymbol + priceNum.toFixed(2) }) : '';
            html += renderItem(fc, titleHtml(p.title, query), sub, C.localizeUrl(p.url));
          });
        }
        if (hasArts) {
          html += '<div class="hdr2__mobile-search-section-label" style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;">' + C.i18n('sectionArticles') + '</div>';
          articles.forEach(function(a) {
            html += renderItem('_globe', titleHtml(a.title || '', query), '', C.localizeUrl(a.url || '#'));
          });
        }

        results.innerHTML = html;
        results.classList.add('is-open');
      }

      function showPopular() {
        var path = window.location.pathname.toLowerCase();
        var isAU = /^\/[a-z]{2}-au(\/|$)/.test(path) || String(window.__GEO_COUNTRY || '').toUpperCase() === 'AU';
        renderResults(C.getPopularDestinations(window.__GEO_COUNTRY, isAU), [], [], [], '', true);
      }

      function searchAll(query) {
        var destMatches = C.matchDestinations(query);
        var countryNames = C.getMatchedCountryNames(query);
        var coverage = C.findCoverageProducts(countryNames);
        var filtered = coverage.length > 0 ? destMatches.filter(function(d) { return d.type === 'region'; }) : destMatches;
        renderResults(filtered, coverage, [], [], query, false);

        C.fetchShopifyResults(query, fetchIdRef, function(products, articles) {
          C.updatePricesFromProducts(products);
          /* Coverage cards and Shopify "Plans" are two views of the same
             catalogue, so a multi-country plan matched by both was listed
             twice (searching "Pakistan" showed Orange Global Explorer under
             "Available Plans" and again under "Plans"). */
          var uniqueProducts = C.dedupeProducts(products, coverage, filtered);
          renderResults(filtered, coverage, uniqueProducts.slice(0, 4), articles.slice(0, C.MAX_BLOG_RESULTS), query, false);
        });
      }

      function updateActiveStyle() {
        var items = results.querySelectorAll('.hdr2__mobile-search-result');
        items.forEach(function(item, i) {
          item.style.background = i === activeIndex ? 'rgba(255, 204, 102,0.1)' : '';
        });
      }

      var clearBtn = document.getElementById('hdr2-mobile-search-clear');
      var submitBtn = document.getElementById('hdr2-mobile-search-submit');
      function toggleActionButtons(hasContent) {
        if (clearBtn) clearBtn.classList.toggle('is-visible', hasContent);
        if (submitBtn) submitBtn.classList.toggle('is-visible', hasContent);
      }

      input.addEventListener('input', function() {
        var q = this.value.trim();
        activeIndex = -1;
        toggleActionButtons(q.length > 0);
        if (q.length < 1) { results.classList.remove('is-open'); return; }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() { searchAll(q); }, C.DEBOUNCE_MS);
      });

      input.addEventListener('focus', function() {
        var q = this.value.trim();
        toggleActionButtons(q.length > 0);
        if (q.length > 0) {
          if (results.innerHTML) results.classList.add('is-open');
          else searchAll(q);
        }
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          input.value = '';
          input.focus();
          toggleActionButtons(false);
          results.classList.remove('is-open');
        });
      }

      input.addEventListener('keydown', function(e) {
        var items = results.querySelectorAll('.hdr2__mobile-search-result');
        if (e.key === 'Escape') { results.classList.remove('is-open'); input.blur(); return; }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex += e.key === 'ArrowDown' ? 1 : -1;
          if (activeIndex < 0) activeIndex = items.length - 1;
          if (activeIndex >= items.length) activeIndex = 0;
          updateActiveStyle();
          if (items[activeIndex]) items[activeIndex].scrollIntoView({ block: 'nearest' });
          return;
        }
        if (e.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault(); window.location.href = items[activeIndex].href;
        }
      });

      var searchContainer = input.closest('.hdr2__mobile-search');
      document.addEventListener('click', function(e) {
        if (!results.classList.contains('is-open')) return;
        if (searchContainer && searchContainer.contains(e.target)) return;
        results.classList.remove('is-open');
        activeIndex = -1;
      });
    }
    init();
  })();

  /* ===== Desktop Nav Search — full-featured via GstarSearchCore ===== */
  (function() {
    var GLOB = {
      '_globe': window.__MM_ASSETS.globe,
      '_globe_eu': window.__MM_ASSETS.globe_eu,
      '_globe_af': window.__MM_ASSETS.globe_af,
      '_globe_as': window.__MM_ASSETS.globe_as,
      '_globe_oc': window.__MM_ASSETS.globe_oc,
      '_globe_na': window.__MM_ASSETS.globe_na,
      '_globe_sa': window.__MM_ASSETS.globe_sa,
      '_globe_world': window.__MM_ASSETS.globe_world
    };
    var FLAG_BASE = window.__MM_ASSETS.flagBase.split('flag-jp.png')[0];
    var flagOpts = { flagBase: FLAG_BASE + 'flag-', globeUrls: GLOB };

    var btn = document.getElementById('hdr2NavSearchBtn');
    var panel = document.getElementById('hdr2NavSearchPanel');
    var input = document.getElementById('hdr2NavSearchInput');
    var results = document.getElementById('hdr2NavSearchResults');
    if (!btn || !panel || !input || !results) return;

    function openPanel() {
      panel.classList.add('is-open'); btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
      setTimeout(function() { try { input.focus(); } catch(e) {} }, 30);
    }
    function closePanel() {
      panel.classList.remove('is-open'); btn.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
      results.classList.remove('is-open');
    }
    btn.addEventListener('click', function(e) { e.stopPropagation(); panel.classList.contains('is-open') ? closePanel() : openPanel(); });
    document.addEventListener('click', function(e) {
      if (!panel.classList.contains('is-open')) return;
      if (!panel.contains(e.target) && !btn.contains(e.target)) closePanel();
    });

    function init() {
      var C = window.GstarSearchCore;
      if (!C) { setTimeout(init, 30); return; }

      var debounceTimer = null;
      var activeIndex = -1;
      var fetchIdRef = { id: 0 };

      function renderItem(flagCode, title, subtitle, url) {
        return '<a href="' + url + '" class="hdr2__nav-search-result">' +
          C.renderFlag(flagCode || '_globe', 36, flagOpts) +
          '<div class="hdr2__nav-search-result__info">' +
            '<p class="hdr2__nav-search-result__title">' + title + '</p>' +
            (subtitle ? '<p class="hdr2__nav-search-result__price">' + subtitle + '</p>' : '') +
          '</div></a>';
      }

      /* Mirrors the hero dropdown: the typed text is bolded inside the result
         title. The header boxes rendered plain escaped text, so the same query
         was highlighted on the homepage and not in the header. escapeHtml
         stays the fallback for the popular list, which has no query. */
      function titleHtml(text, query) {
        return query ? C.highlightMatch(text, query) : C.escapeHtml(text);
      }

      function renderResults(dests, coverage, products, articles, query, isPopular) {
        var hasDests = dests && dests.length > 0;
        var hasCov = coverage && coverage.length > 0;
        var hasProds = products && products.length > 0;
        var hasArts = articles && articles.length > 0;

        if (!hasDests && !hasCov && !hasProds && !hasArts) {
          results.innerHTML = '<div class="hdr2__nav-search-no-results">' +
            C.i18n('noResultsFor', { query: C.escapeHtml(query) }) +
            '<br><span style="font-size:0.8rem;color:#94a3b8;margin-top:4px;display:inline-block;">' + C.i18n('tryHint') + '</span>' +
            C.helpLinksHtml() + '</div>';
          results.classList.add('is-open'); return;
        }

        /* Continent-level query → Regions before Plans (same rule as
           homepage hero + mobile-drawer search). */
        var continentPriority = !isPopular && hasDests && C.isContinentQuery && C.isContinentQuery(query, dests);

        var html = '';
        if (isPopular) html += '<div class="hdr2__nav-search-section-label">' + C.i18n('sectionPopular') + '</div>';

        function appendCoverage() {
          if (!hasCov) return;
          if (!isPopular) {
            var topBorder = continentPriority ? ' style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;"' : '';
            html += '<div class="hdr2__nav-search-section-label"' + topBorder + '>' + C.i18n('sectionAvailable') + '</div>';
          }
          coverage.forEach(function(p) {
            var fc = C.getFlagForProduct(p.t) || C.getFlagForHandle(p.h) || '_globe';
            var cLabel = p.c === 1 ? '' : ' <span style="font-size:0.7rem;background:#f1f5f9;border-radius:999px;padding:2px 6px;">' + C.i18n('nCountries', { count: p.c }) + '</span>';
            html += renderItem(fc, titleHtml(p.t, query) + cLabel, C.i18n('priceFrom', { price: C.currencySymbol + (p.p / 100).toFixed(2) }), C.localizeUrl('/products/' + p.h));
          });
        }
        function appendDests() {
          if (!hasDests) return;
          dests.forEach(function(d) {
            var sub = C.priceCache[d.name] ? C.i18n('priceFrom', { price: C.priceCache[d.name] }) : C.i18n('browseCollection');
            html += renderItem(d.flag, titleHtml(d.name, query), sub, C.localizeUrl(C.resolveDestUrl(d.url)));
          });
        }

        if (continentPriority) { appendDests(); appendCoverage(); }
        else { appendCoverage(); appendDests(); }

        if (hasProds) {
          if (!isPopular) html += '<div class="hdr2__nav-search-section-label" style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;">Plans</div>';
          products.forEach(function(p) {
            var fc = C.getFlagForProduct(p.title) || '_globe';
            var priceNum = parseFloat(p.price_min || p.price || '0');
            var sub = priceNum > 0 ? C.i18n('priceFrom', { price: C.currencySymbol + priceNum.toFixed(2) }) : '';
            html += renderItem(fc, titleHtml(p.title, query), sub, C.localizeUrl(p.url));
          });
        }
        if (hasArts) {
          html += '<div class="hdr2__nav-search-section-label" style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;">' + C.i18n('sectionArticles') + '</div>';
          articles.forEach(function(a) {
            html += renderItem('_globe', titleHtml(a.title || '', query), '', C.localizeUrl(a.url || '#'));
          });
        }

        results.innerHTML = html;
        results.classList.add('is-open');
      }

      function showPopular() {
        var path = window.location.pathname.toLowerCase();
        var isAU = /^\/[a-z]{2}-au(\/|$)/.test(path) || String(window.__GEO_COUNTRY || '').toUpperCase() === 'AU';
        renderResults(C.getPopularDestinations(window.__GEO_COUNTRY, isAU), [], [], [], '', true);
      }

      function searchAll(query) {
        var destMatches = C.matchDestinations(query);
        var countryNames = C.getMatchedCountryNames(query);
        var coverage = C.findCoverageProducts(countryNames);
        var filtered = coverage.length > 0 ? destMatches.filter(function(d) { return d.type === 'region'; }) : destMatches;
        renderResults(filtered, coverage, [], [], query, false);

        C.fetchShopifyResults(query, fetchIdRef, function(products, articles) {
          C.updatePricesFromProducts(products);
          /* Coverage cards and Shopify "Plans" are two views of the same
             catalogue, so a multi-country plan matched by both was listed
             twice (searching "Pakistan" showed Orange Global Explorer under
             "Available Plans" and again under "Plans"). */
          var uniqueProducts = C.dedupeProducts(products, coverage, filtered);
          renderResults(filtered, coverage, uniqueProducts.slice(0, 4), articles.slice(0, C.MAX_BLOG_RESULTS), query, false);
        });
      }

      function updateActiveStyle() {
        var items = results.querySelectorAll('.hdr2__nav-search-result');
        items.forEach(function(item, i) {
          item.style.background = i === activeIndex ? 'rgba(255, 204, 102,0.1)' : '';
        });
      }

      var clearBtn = document.getElementById('hdr2NavSearchClear');
      var submitBtn = panel.querySelector('.hdr2__nav-search-submit');
      function toggleActionButtons(hasContent) {
        if (clearBtn) clearBtn.classList.toggle('is-visible', hasContent);
        if (submitBtn) submitBtn.classList.toggle('is-visible', hasContent);
      }

      input.addEventListener('input', function() {
        var q = this.value.trim();
        activeIndex = -1;
        toggleActionButtons(q.length > 0);
        if (q.length < 1) { showPopular(); return; }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() { searchAll(q); }, C.DEBOUNCE_MS);
      });

      input.addEventListener('focus', function() {
        var q = this.value.trim();
        toggleActionButtons(q.length > 0);
        if (q.length === 0) showPopular();
        else if (results.innerHTML) results.classList.add('is-open');
        else searchAll(q);
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          input.value = '';
          input.focus();
          toggleActionButtons(false);
          showPopular();
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && panel.classList.contains('is-open')) { closePanel(); return; }
        if (!panel.classList.contains('is-open')) return;
        var items = results.querySelectorAll('.hdr2__nav-search-result');
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex += e.key === 'ArrowDown' ? 1 : -1;
          if (activeIndex < 0) activeIndex = items.length - 1;
          if (activeIndex >= items.length) activeIndex = 0;
          updateActiveStyle();
          if (items[activeIndex]) items[activeIndex].scrollIntoView({ block: 'nearest' });
          return;
        }
        if (e.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault(); window.location.href = items[activeIndex].href;
        }
      });
    }
    init();
  })();

  /* ===== Geo-restricted nav items (SIM Cards, Travel Accessories = AU only) ===== */
  /* Skip in Theme Editor — show all items for editing */
  (function() {
    if (window.Shopify && window.Shopify.designMode) return;

    var geoItems = document.querySelectorAll('[data-nav-geo]');
    if (!geoItems.length) return;

    // Detect country from: 1) URL locale prefix, 2) meta tag shop-country
    var path = window.location.pathname.toLowerCase();
    var m = path.match(/^\/[a-z]{2}-([a-z]{2})(\/|$)/);
    var country = m ? m[1].toUpperCase() : null;

    // Fallback: check Shopify market country from meta tag
    if (!country) {
      var metaCountry = document.querySelector('meta[name="shop-country"]');
      if (metaCountry) country = (metaCountry.content || '').toUpperCase();
    }

    geoItems.forEach(function(el) {
      var restrict = (el.getAttribute('data-nav-geo') || '').toUpperCase();
      if (country === restrict) {
        el.style.display = '';
      }
    });
  })();
})();
